import axios from "axios";

const portalUrl = "https://www.canarabank.bank.in";

/* ============================
   AUTH TOKEN
   ============================ */
export const getAuthToken = async () => {
  try {
    const body = new URLSearchParams();
    body.append("client_id", "id-aa542798-ccfe-94dc-4410-da4ef3ba59aa");
    body.append("client_secret", "secret-5bbd9014-5795-76c8-168e-509d2bbfa2ba");
  // body.append("client_id", "id-c4f649ba-e53d-c449-6d38-71ee8c2abeb");
   //  body.append("client_secret", "secret-20d5689e-15c1-df24-8e9b-89ca5cd43c6");
    body.append("grant_type", "client_credentials");
    const response = await axios.post(
      `${portalUrl}/o/oauth2/token`,
      body,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
      }
    );

    return response.data.access_token;
  } catch (err) {
    console.warn("Token error:", err.message);
    return null;
  }
};

/* ============================
   ATM STATES (ONLY STATES)
   ============================ */
export const getATMStates = async () => {
  const token = await getAuthToken();

  if (!token) {
    throw new Error("No access token available");
  }

  const response = await fetch(
    `${portalUrl}/o/c/atmlocators?pageSize=0&field=state`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(`State API failed: ${response.status}`);
  }

  const data = await response.json();

  // 🔹 Robust state deduplication (case-insensitive + trim)
  const stateMap = new Map();

  data.items.forEach(item => {
    const rawState = item.state;
    if (!rawState) return;

    const normalized = rawState.trim().toUpperCase();

    if (!stateMap.has(normalized)) {
      stateMap.set(normalized, rawState.trim());
    }
  });

  return Array.from(stateMap.values()).sort();
};

/* ============================
   ATM DISTRICTS (STATE INPUT)
   ============================ */
export const getATMDistricts = async (state) => {
  if (!state) {
    return [];
  }

  const token = await getAuthToken();

  if (!token) {
    throw new Error("No access token available");
  }

  const response = await fetch(
    `${portalUrl}/o/c/atmlocators?pageSize=0&filter=state eq '${state}'&field=district`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(`District API failed: ${response.status}`);
  }

  const data = await response.json();

  // 🔹 Robust district deduplication (case-insensitive + trim)
  const districtMap = new Map();

  data.items.forEach(item => {
    const rawDistrict = item.district;
    if (!rawDistrict) return;

    const normalized = rawDistrict.trim().toUpperCase();

    if (!districtMap.has(normalized)) {
      districtMap.set(normalized, rawDistrict.trim());
    }
  });

  return Array.from(districtMap.values()).sort();
};
export const searchATMs = async (state, district, branch) => {
  const token = await getAuthToken();
  if (!token) throw new Error("No access token");

  const filters = [];

  if (state) {
    filters.push(`state eq '${state}'`);
  }

  if (district) {
    filters.push(`district eq '${district}'`);
  }


  const response = await fetch(
    `${portalUrl}/o/c/atmlocators?pageSize=50&filter=${filters.join(" and ")}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error("Search API failed");
  }

  const data = await response.json();
  console.log(data);
  return data.items || [];
};
